// Wechselsysteme: weapons.funktion_typ (1 = Grundwaffe, 2 = Wechselsystem) + parent_weapon_id

export function isSystem(weapon) {
  return Number(weapon.funktion_typ) === 2;
}

export function systemsOf(weapons, weapon) {
  return (weapons || []).filter(
    w => isSystem(w) && Number(w.parent_weapon_id) === Number(weapon.id)
  );
}

// Sortiert mit `compare`, hält Wechselsysteme aber direkt unter ihrer Grundwaffe.
// Systeme, deren Grundwaffe nicht in `items` steht, laufen als eigene Zeile mit.
export function groupWithSystems(items, compare) {
  const ids = new Set(items.map(i => Number(i.id)));
  const children = {};
  const topLevel = [];
  items.forEach(i => {
    const parentId = Number(i.parent_weapon_id);
    if (isSystem(i) && parentId && ids.has(parentId)) {
      if (!children[parentId]) children[parentId] = [];
      children[parentId].push(i);
    } else {
      topLevel.push(i);
    }
  });

  const sorted = [];
  topLevel.sort(compare).forEach(top => {
    sorted.push(top);
    (children[Number(top.id)] || []).sort(compare).forEach(c => sorted.push(c));
  });
  return sorted;
}

// Vergleich nach einer Spalte, leere Werte ans Ende, Zahlen natürlich sortiert
export function compareBy(key, desc = false) {
  return (a, b) => {
    if (!key) return 0;
    const x = a[key];
    const y = b[key];
    if (x == null && y == null) return 0;
    if (x == null) return 1;
    if (y == null) return -1;
    const result = String(x).localeCompare(String(y), "de", { numeric: true });
    return desc ? -result : result;
  };
}
